export const API_ROUTES = {
  BOOT: '/game-portal/boot',
  OTP: '/store/otp/deeplink',
  PAGES: '/game-portal/pages',
  LOGIN: '/store/auth/login',
  REDIRECT_TOKEN: '/game-portal/auth/portal-redirect',
  KEEP_ALIVE: '/store/auth/keepalive'
};
